import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import ShopServices from './shop_service';

export const searchProducts = createAsyncThunk(
  'shop/search_products',
  async (payload, thunkAPI) => {
    try {
      // Make sure payload includes brand parameter

      const response = await ShopServices.SearchProducts(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
